import { ContextMenu } from 'primereact/contextmenu';
import { createContext, useRef, useState } from 'react';
import styles from '../components/assets/context-menu.module.css';
import { useRpc } from './RpcContext';
import { MenuItem } from 'primereact/menuitem';
interface IContextMenuContext {
  menuItems: any[];
  clearItems: () => void;
  setMenuItems: any;
  cmRef: any;
}
// Создаём контекст
const ContextMenuContext = createContext<IContextMenuContext | undefined>(
  undefined
);

// Провайдер контекста
export const ContextMenuProvider = ({ children }: { children: any }) => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const cmRef = useRef<ContextMenu>(null);
  // Функция для очистки всех элементов
  const clearItems = () => {
    setMenuItems([]);
  };

  const { wsOpened } = useRpc();

  return (
    <ContextMenuContext.Provider
      value={{ menuItems, clearItems, setMenuItems, cmRef }}
    >
      {wsOpened && (
        <ContextMenu
          ref={cmRef}
          className={styles.contextMenu}
          model={menuItems}
        />
      )}
      {children}
    </ContextMenuContext.Provider>
  );
};

export default ContextMenuContext;
